export class UserMessage {
    ID: number;
    Enabled: boolean;
    MessageText: string;
}

export default UserMessage;